import { on } from '@ember/modifier';
import { action } from '@ember/object';

import type { PopupData, PopupListItem } from 'webapp-types';

import CommonUiIconComponent from 'webapp/components/common/ui-icon';
import PopupInnerContextComponent from 'webapp/components/popup/inner/context';
import SearchableListItemComponent from 'webapp/components/searchable-list-item';

export default class CustomQuerySetupCommonDimensionSelectorPopupComponent extends PopupInnerContextComponent<PopupData.CustomQuery.SelectPreviewDimension> {
	get itemsList(): PopupListItem<string>[] {
		return this.popupData.options.map((option) => ({
			id: option.key,
			text: option.value,
			isSelected: option.key === this.popupData.selected,
		}));
	}

	@action
	selectItem(item: PopupListItem<string>): void {
		this.popupData.onSelect(item.id as string);
		this.close();
	}

	@action
	refreshList(): void {
		this.popupData.onRefresh();
		this.close();
	}
	<template>
		<ul class="links context-ct">
			{{#each this.itemsList as |item|}}
				<SearchableListItemComponent
					@item={{item}}
					@onTriggerAction={{this.selectItem}}
					@showTextProperty="text"
				/>
			{{/each}}
		</ul>

		<a role="button" class="button-refresh" {{on "click" this.refreshList}}>
			<CommonUiIconComponent @name="Refresh" @size="sm" />
			<span>Refresh list</span>
		</a>
	</template>
}
